import React, { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import parse from "html-react-parser"
import { withRouter } from "react-router-class-tools";

import { styled } from "../stitches.config";
import Breadcrumbs from "../redesign/components/Breadcrumbs";

import DotsNatemat from "../redesign/assets/icons/infopage-natemat.svg"
import DotsInnpoland from "../redesign/assets/icons/infopage-innpoland.svg"
import DotsAszdziennik from "../redesign/assets/icons/infopage-aszdziennik.svg"
import DotsMamadu from "../redesign/assets/icons/infopage-mamadu.svg"
import DotsDadhero from "../redesign/assets/icons/infopage-dadhero.svg"
import DotsTopnewsy from "../redesign/assets/icons/infopage-topnewsy.svg"

import Arrow from "../redesign/assets/icons/arrow-up.svg"
import Close from "../redesign/assets/icons/close-podcast.svg"
import Footer from "../redesign/components/Footer"

import { body, h4Strong } from "../redesign/commonStyles/Fonts";

const InfoPage = props => {
    const [data, setData] = useState('')
    const [tableOfContents, setTableOfContents] = useState([])
    const [isMenuOpen, setMenuOpen] = useState(false);
    const toggleMenu = () => {
        setMenuOpen(!isMenuOpen);
    };

    const location = useLocation()
    const pageName = props.match.params.slug;
    const isDesktop = window.innerWidth > 996;

    useEffect(() => {
        const { slug } = props.match.params;
        const fetchInfoPage = async () => {
            const res = await fetch(`${window.API_HOST}/pwa-info/${slug}`)
            if (!res.ok) {
                Promise.reject(res.status)
            }
            const data = await res.json()
            setData(data.html)
            setTableOfContents(data.tableOfContents)
        }
        fetchInfoPage()
    }, [location])

    return (
        <>
            <WrapBizon>
                <div className="container">
                    <Breadcrumbs category={{
                        name: `${pageName}`, link: `/info/${pageName}`
                    }} invert />
                    <FlexWrapper>
                        {tableOfContents.length > 0 ?
                            <LeftColumn className={body()}>
                                <LeftColumnMobileMenu onClick={toggleMenu}>
                                    <p className={h4Strong()}><span></span>Przejdź do sekcji...</p>
                                    {isMenuOpen ?
                                        <div className="close"></div>
                                        :
                                        <div className="arrow"></div>
                                    }
                                </LeftColumnMobileMenu>
                                <LeftColumnContent onClick={toggleMenu} className={!isDesktop && isMenuOpen ? "open" : ""}>
                                    {tableOfContents.map((item, index) => (
                                        <a key={index} href={item.target}>{item.title}</a>
                                    ))}
                                </LeftColumnContent>
                            </LeftColumn>
                            :
                            null
                        }
                        <RightColumn
                            className={"info-page--" + window.BRAND}>
                            {parse(data)}
                        </RightColumn>
                    </FlexWrapper>
                </div>
            </WrapBizon>
            <Footer />
        </>
    )
}
const WrapBizon = styled("div", {
    background: "$grayscale10",
    padding: "64px 0 0 0",
    position: "relative",
    "@bp4": {
        padding: "40px 0 0 0",
    },
    "& .breadcrumbs": {
        "& ul": {
            "& li:nth-child(2)": {
                textTransform: "capitalize",
            },
        },
    },
    ".info-page--natemat": {
        "& .centered": {
            "&:before": {
                backgroundImage: `url("${DotsNatemat}")`,
            }
        }
    },
    ".info-page--mamadu": {
        "& .centered": {
            "&:before": {
                backgroundImage: `url("${DotsMamadu}")`,
            }
        }
    },
    ".info-page--dadhero": {
        "& .centered": {
            "&:before": {
                backgroundImage: `url("${DotsDadhero}")`,
            }
        }
    },
    ".info-page--innpoland": {
        "& .centered": {
            "&:before": {
                backgroundImage: `url("${DotsInnpoland}")`,
            }
        }
    },
    ".info-page--aszdziennik": {
        "& .centered": {
            "&:before": {
                backgroundImage: `url("${DotsAszdziennik}")`,
            }
        }
    },
    ".info-page--topnewsy": {
        "& .centered": {
            "&:before": {
                backgroundImage: `url("${DotsTopnewsy}")`,
            }
        }
    },
});

const FlexWrapper = styled("div", {
    marginTop: "24px",
    "@bp4": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        maxWidth: "1164px",
    },
});

const LeftColumnMobileMenu = styled("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
    background: "$grayscale0",
    color: "$grayscale100",
    padding: "0 20px",
    borderBottom: "1px solid $grayscale25",
    "@bp4": {
        display: "none",
    },
    "& p": {
        position: "relative",
        paddingLeft: "16px",
        "&:before": {
            content: "",
            position: "absolute",
            display: "block",
            left: 0,
            top: "6px",
            width: "6px",
            height: "6px",
            backgroundColor: "$primary",
            borderRadius: "6px",
        },
        "&:after": {
            content: "",
            position: "absolute",
            display: "block",
            top: "14px",
            left: 0,
            width: "6px",
            height: "6px",
            backgroundColor: "$primary",
            borderRadius: "6px",
        },
    }
});

const LeftColumnContent = styled("div", {
    padding: "0px",
    width: "100%",
    overflow: "hidden",
    height: "0px",
    "@bp4": {
        height: "auto",
        width: "260px",
        padding: "32px 40px 24px 40px",
        flexShrink: 0,
        minHeight: "20px",
    },
    "& a": {
        color: "$grayscale100",
        display: "block",
        marginBottom: "8px",
    },
});

const LeftColumn = styled("div", {
    width: "100%",
    background: "$grayscale0",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 10,
    "@bp4": {
        width: "260px",
        position: "static",
        marginRight: "20px",
    },
    "@bp5": {
        width: "300px",
    },
    "& .open": {
        height: "auto",
        padding: "16px 16px 8px 16px",
    },
    "& .close": {
        width: "12px",
        height: "12px",
        backgroundImage: `url("${Close}")`,
        backgroundPosition: "center",
        backgroundSize: "cover",
    },
    "& .arrow": {
        width: "14px",
        height: "8px",
        backgroundImage: `url("${Arrow}")`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        transform: "rotate(90deg)"
    },
});

const RightColumn = styled("div", {
    marginTop: "30px",
    marginBottom: "100px",
    fontFamily: "Charis SIL",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "26px",
    letterSpacing: "0.1px",
    color: "$grayscale100",
    width: "100%",
    "@bp4": {
        fontSize: "24px",
        lineHeight: "30px",
        maxWidth: "732px",
    },
    "& ol": {
        fontFamily: "Charis SIL",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "26px",
        letterSpacing: "0.1px",
        paddingLeft: "16px",
        "@bp4": {
            fontSize: "24px",
            lineHeight: "30px",
            paddingLeft: "24px",
        },

        "& li": {
            marginBottom: "15px",
        }
    },

    "& a": {
        color: "$primary",
        "&:hover": {
            color: "$primary",
        }
    },

    "& h1": {
        fontSize: "36px",
        fontFamily: "HK Grotesk",
    },

    "& h2": {
        fontFamily: "HK Grotesk",
        fontSize: "24px",
        fontWeight: "700",
        lineHeight: "30px",
        letterSpacing: "0.2px",
        "@bp4": {
            fontSize: "38px",
            lineHeight: "42px",
        }
    },

    "& .centered": {
        textAlign: "left",
        fontFamily: "HK Grotesk",
        fontSize: "24px",
        fontWeight: "700",
        lineHeight: "30px",
        letterSpacing: "0.2px",
        position: "relative",
        padding: "32px 0 16px 0",
        "@bp4": {
            padding: "56px 0 16px 0",
            fontSize: "38px",
            lineHeight: "42px",
        },
        "&:before": {
            content: "",
            position: "absolute",
            top: 0,
            left: 0,
            width: "54px",
            height: "7px",
            backgroundSize: "cover",
            backgroundPosition: "center",
            "@bp4": {
                width: "76px",
                height: "10px",
            }
        }
    },
});

export default withRouter(InfoPage);